import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function TargetAudienceSection() {
  return <section className="py-20 bg-[#0a0e27] relative" data-id="element-390">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-391">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-392">
          {/* Who it's for */}
          <div className="bg-green-900/10 border border-green-500/20 rounded-3xl p-8 md:p-10" data-id="element-393">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 flex items-center" data-id="element-394">
              <span className="bg-green-500/20 text-green-400 p-2 rounded-lg mr-4" data-id="element-395">
                <CheckCircle2 className="w-6 h-6" data-id="element-396" />
              </span>
              Esto SÍ es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-397">
              <li className="flex items-start" data-id="element-398">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-399" />
                <span className="text-gray-300 text-lg" data-id="element-400">
                  Sientes que tu "suerte" cambió de golpe y nada te sale bien,
                  sin explicación lógica.
                </span>
              </li>
              <li className="flex items-start" data-id="element-401">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-402" />
                <span className="text-gray-300 text-lg" data-id="element-403">
                  Eres emprendedor, líder o persona visible y sufres de envidias
                  constantes que frenan tu progreso.
                </span>
              </li>
              <li className="flex items-start" data-id="element-404">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-405" />
                <span className="text-gray-300 text-lg" data-id="element-406">
                  Padeces de cansancio crónico, pesadillas o insomnio que los
                  médicos no logran explicar.
                </span>
              </li>
              <li className="flex items-start" data-id="element-407">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-408" />
                <span className="text-gray-300 text-lg" data-id="element-409">
                  Sospechas firmemente ser víctima de trabajos de magia, mal de
                  ojo o entidades parasitarias.
                </span>
              </li>
            </ul>
          </div>

          {/* Who it's not for */}
          <div className="bg-red-900/10 border border-red-500/20 rounded-3xl p-8 md:p-10" data-id="element-410">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 flex items-center" data-id="element-411">
              <span className="bg-red-500/20 text-red-400 p-2 rounded-lg mr-4" data-id="element-412">
                <XCircle className="w-6 h-6" data-id="element-413" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-414">
              <li className="flex items-start" data-id="element-415">
                <XCircle className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-416" />
                <span className="text-gray-300 text-lg" data-id="element-417">
                  Buscas este conocimiento para dañar, manipular o vengarte de
                  otras personas (magia negra).
                </span>
              </li>
              <li className="flex items-start" data-id="element-418">
                <XCircle className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-419" />
                <span className="text-gray-300 text-lg" data-id="element-420">
                  Esperas resultados "mágicos" instantáneos sin estar dispuesto
                  a seguir las instrucciones y protocolos de la guía.
                </span>
              </li>
              <li className="flex items-start" data-id="element-421">
                <XCircle className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-422" />
                <span className="text-gray-300 text-lg" data-id="element-423">
                  No crees en la energía y piensas que todo es pura coincidencia
                  o sugestión psicológica.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}